import * as React from "react";
import {Dropdown, DropdownItemProps} from "semantic-ui-react";
import {useContext, useEffect, useState} from "react";
import {CompanyConfiguration, StatusReportConfiguration} from "../../../../../generated";
import {ConfigContext} from "../../../context/ConfigContext";
import {DropdownProps} from "semantic-ui-react/dist/commonjs/modules/Dropdown/Dropdown";
import {updateConfig, workingConfig} from "../../configChange/ConfigSignal";
import {configStorage} from "../../../../../ConfigStorage";
import {signal, Signal} from "@preact/signals-react";

export interface ReportScriptSelectionProps {
}

export const selectedReportScript: Signal<string | null> = signal(null)
export const selectedReportScriptPath: Signal<string | null> = signal(null)

export function ReportScriptSelection(props: React.PropsWithChildren<ReportScriptSelectionProps>) {

    const context = useContext(ConfigContext)


    const [selectedReport, setSelectedReport] = useState<DropdownProps>(null)
    const [config, setConfig] = useState<CompanyConfiguration>(null)

    useEffect(() => {
        if (workingConfig.value) {
            setConfig(JSON.parse(workingConfig.value))
        } else {
            configStorage.getElement(context.companyId).then((c) => {
                setConfig(c.config)
                updateConfig(JSON.stringify(config, null, 4), false, false)
            })

        }

    }, [])

    useEffect(() => {
        if(config != null && selectedReportScriptPath.value != null) {
            // find index of selectedReportScriptPath.value in config
            let index = selectedReportScriptPath.value.split('.')[4]
            let option = specificDropdownOptions()[index]
            setSelectedReport(option)
        }
    }, [config]);

    function onSelection(selected: DropdownProps) {

        if (selected?.value) {
            let i = config?.uiUiViewConfiguration?.statusMonitoring?.reports?.findIndex(sc =>
                sc.name == (JSON.parse(selected?.value as string) as StatusReportConfiguration).name
            )
            setSelectedReport(selected)
            selectedReportScript.value = (JSON.parse(selected?.value as string) as StatusReportConfiguration).reportScript
            selectedReportScriptPath.value = "$.uiUiViewConfiguration.statusMonitoring.reports." +
                i +
                ".reportScript"
        }
    }

    function specificDropdownOptions() {
        let options: Array<DropdownItemProps> = [];

        let index = 0

        config.uiUiViewConfiguration.statusMonitoring.reports?.forEach(s => {
            options.push({
                key: index,
                value: JSON.stringify(s, null, 4),
                text: s.name,
            })
            index++
        })
        return options
    }

    function drawPathSelection() {

        if (config?.uiUiViewConfiguration?.statusMonitoring?.reports?.length > 0) {
            return <>
                <Dropdown
                    selectOnBlur={false}
                    readOnly={false}
                    options={specificDropdownOptions()}
                    selection
                    value={selectedReport?.value}
                    onChange={(evt, data) =>
                        onSelection(data)
                    }
                />
            </>
        } else {
            return <p>There is no genericXlsConfiguration in your current config</p>
        }
    }

    return <div style={{
        flex: 1,
        display: "flex",
        flexDirection: "row",
        maxHeight: "40px"
    }}>
        <h1>select the script: </h1>
        {drawPathSelection()}
    </div>
}